import {IToJson} from '@toolify/client/src/types/IToJson'
import {IDeploymentVersionItemResponseInstance} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/IDeploymentVersionItemResponseInstance'

export function mapDeploymentVersionItemResponseInstance(
  item: IToJson<IDeploymentVersionItemResponseInstance>,
): IDeploymentVersionItemResponseInstance {
  return {
    ...item,
    seenAt: item.seenAt,
  }
}
